/** @format */

import React, { useState } from "react";
import { useNavigate, Link, NavLink } from "react-router-dom";
import { Formik, Form } from "formik";
import FormControl from "../forms/FormControl";
import Button from "./Button";
import { MdCancel } from "react-icons/md";
import { FaSpinner, FaGoogle } from "react-icons/fa";
import * as Yup from "yup";
import { useAuth } from "../context/AuthContext";
import { auth, db, getDocs, usersCol } from "../firebase/utils";
import { ACTIONS } from "../reducer/authReducer";

const Login = () => {
  //FUNCTIONS FROM AUTHCONTEXT
  const {
    authState,
    handleHidePopup,
    handleShowSignupPopup,
    loginUser,
    googleSignIn,
    closeToast,
    dispatch,
  } = useAuth();

  const { loginPopupState } = authState; // THE STATE OF THE LOGIN MODAL POP-UP

  let navigate = useNavigate();

  //INITIALVALUES REQUIRED BY REACT FORMIK LIB
  const initialValues = {
    email: "",
    password: "",
  };

  //YUP FORM VALIDATION SCHEMA
  const validationSchema = Yup.object({
    email: Yup.string().email().required("Required"),
    password: Yup.string().min(6).required("Required"),
  });

  //ON SUBMIT FORMIK OBJECT
  const onSubmit = (values, onSubmitProps) => {
    console.log(onSubmitProps);
    const { setSubmitting } = onSubmitProps;
    const { email, password } = values;
    loginUser(auth, email, password)
      .then(
        (res) => (
          dispatch({ type: ACTIONS.SET_TOAST_SUCCESSFULL }),
          navigate("/profile-update"),
          closeToast(),
          handleHidePopup(),
          onSubmitProps.resetForm()
        )
      )
      .catch((err) => {
        //INCASE OF A LOGIN ERROR, WE GET RED-TOAST (WITH FAILURE MESSAGE) AND SETSUBMMITING
        //IN OTHER TO STOP SPINNER FROM SPINNING FOREVER
        dispatch({ type: ACTIONS.SET_TOAST_FAILURE });
        setSubmitting(false);
        closeToast();
      });

    navigate("/profile-update");

    return;
  };

  if (loginPopupState) {
    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => {
          return (
            <div className="login__form">
              <Form className="form">
                <div className="form__title--container">
                  <h2 className="form__title">LOGIN</h2>
                  <MdCancel
                    onClick={handleHidePopup}
                    style={{ color: "rgb(202,8,8)", fontSize: "1.2rem" }}
                  />
                </div>
                <hr />
                <FormControl
                  control="input"
                  name="email"
                  label="Email"
                  placeholder="please enter email"
                  type="text"
                />

                <FormControl
                  control="input"
                  name="password"
                  label="Password"
                  type="password"
                  placeholder="please enter password"
                />

                <div className="reset__password">
                  <Link to="/">Forgot password?</Link>
                  <Link to="/" onClick={handleShowSignupPopup}>
                    Register
                  </Link>
                </div>

                <div
                  style={{
                    position: "relative",
                    margin: "1rem 0",
                  }}
                >
                  <hr />
                  <h3
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%,-50%)",
                      padding: "0.25rem 1rem",
                      backgroundColor: "var(--light)",
                    }}
                  >
                    OR
                  </h3>
                </div>

                <NavLink
                  to="/"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => {
                    googleSignIn()
                      .then((res) => navigate("/profile-update"))
                      .catch((err) => console.log(err.message));

                    return handleHidePopup();
                  }}
                >
                  Sign with google
                  <FaGoogle style={{ color: "red", margin: "0 0.25rem" }} />
                </NavLink>

                <div className="submit__button">
                  <Button
                    // onClick={handleCurrentUserTrue}
                    btnText={
                      formik.isSubmitting ? (
                        <FaSpinner className="spinner"></FaSpinner>
                      ) : (
                        "Submit"
                      )
                    }
                    color="#fff"
                    type="submit"
                    bg="var(--success)"
                    btnBlock
                    disabled={!formik.isValid || formik.isSubmitting}
                  />
                  {!formik.isValid && (
                    <small style={{ color: "red", textAlign: "center" }}>
                      kindly fill all required fields...
                    </small>
                  )}
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
    );
  } else {
    return <div></div>;
  }
};

export default Login;
